import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import Header from '../components/common/Header'; 
import UserSidebar from '../components/common/UserSidebar'; 
import { customerService } from '../services/customerService'; 
import { toast } from 'react-toastify';

const UserProfilePage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    
    const [formData, setFormData] = useState({
        username: '',
        accountName: '', 
        email: '',
        phone: '',
        address: ''
    });

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const userStr = localStorage.getItem('user_info');
                if (userStr) {
                    const user = JSON.parse(userStr);
                    setFormData(prev => ({ ...prev, ...user }));
                }

                const response = await customerService.getProfile();
                const userData = response.data || response;
                
                setFormData({
                    username: userData.username || '',
                    accountName: userData.accountName || '', 
                    email: userData.email || '',
                    phone: userData.phone || '',
                    address: userData.address || ''
                });

                localStorage.setItem('user_info', JSON.stringify(userData));
            } catch (error) {
                console.error('Lỗi lấy thông tin:', error);
                if (error.response && error.response.status === 401) {
                    navigate('/login');
                }
            } finally {
                setFetching(false);
            }
        };

        fetchUserProfile();
    }, [navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await customerService.updateProfile(formData);
            
            toast.success('Cập nhật thông tin thành công!');
            
            const userStr = localStorage.getItem('user_info');
            if (userStr) {
                const oldUser = JSON.parse(userStr);
                const newUser = { ...oldUser, ...formData };
                localStorage.setItem('user_info', JSON.stringify(newUser));
                
                window.dispatchEvent(new Event('storage')); 
            }
        } catch (error) {
            console.error('Lỗi cập nhật:', error);
            toast.error(error.response?.data || 'Có lỗi xảy ra khi cập nhật thông tin!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            
            <main className="container mx-auto px-4 py-8 flex-grow">
                <div className="flex flex-col md:flex-row gap-6">
                    <UserSidebar user={formData} />

                    {/* 👉 ĐÃ ĐỒNG BỘ NỀN & VIỀN */}
                    <div className="flex-1 bg-gradient-to-b from-orange-50 to-white rounded-xl shadow-sm border border-orange-200/60 p-6 md:p-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-1">Hồ Sơ Của Tôi</h2>
                        <p className="text-sm text-gray-500 mb-6 pb-4 border-b border-orange-200/60">Quản lý thông tin hồ sơ để bảo mật tài khoản</p>

                        {fetching ? (
                            <div className="flex justify-center py-10">
                                <div className="animate-spin h-8 w-8 border-4 border-tnc-orange border-t-transparent rounded-full"></div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="max-w-2xl">
                                <div className="space-y-5">
                                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                                        <label className="md:w-1/4 text-sm font-medium text-gray-600">Tên đăng nhập</label>
                                        <input type="text" disabled value={formData.username} className="flex-1 px-4 py-2 bg-gray-100 border border-gray-200 rounded-lg text-sm text-gray-500 cursor-not-allowed" />
                                    </div>
                                    
                                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                                        <label className="md:w-1/4 text-sm font-medium text-gray-600">
                                            Họ và tên <span className="text-tnc-orange">*</span>
                                        </label>
                                        <input 
                                            type="text" 
                                            name="accountName" 
                                            value={formData.accountName} 
                                            onChange={handleChange} 
                                            required 
                                            placeholder="Nhập họ và tên..." 
                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white" 
                                        />
                                    </div>

                                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                                        <label className="md:w-1/4 text-sm font-medium text-gray-600">Email</label>
                                        <input 
                                            type="email" 
                                            name="email" 
                                            value={formData.email} 
                                            onChange={handleChange} 
                                            placeholder="Nhập địa chỉ email..." 
                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white" 
                                        />
                                    </div>

                                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                                        <label className="md:w-1/4 text-sm font-medium text-gray-600">
                                            Số điện thoại <span className="text-tnc-orange">*</span>
                                        </label>
                                        <input 
                                            type="tel" 
                                            name="phone" 
                                            value={formData.phone} 
                                            onChange={handleChange} 
                                            required 
                                            placeholder="Nhập số điện thoại..." 
                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white" 
                                        />
                                    </div>

                                    <div className="flex flex-col md:flex-row gap-2 md:gap-4">
                                        <label className="md:w-1/4 text-sm font-medium text-gray-600 mt-2">Địa chỉ</label>
                                        <textarea 
                                            name="address" 
                                            value={formData.address} 
                                            onChange={handleChange} 
                                            placeholder="Nhập địa chỉ giao hàng mặc định..." 
                                            rows="3" 
                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange resize-none bg-white"
                                        ></textarea>
                                    </div>

                                    <div className="flex md:justify-end pt-4 border-t border-orange-100">
                                        <button type="submit" disabled={loading} className="w-full md:w-auto bg-tnc-orange hover:bg-tnc-orange-hover text-white font-bold py-2.5 px-8 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 shadow-sm">
                                            {loading ? <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span> : <Save size={18} />}
                                            Lưu thay đổi
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UserProfilePage;